import styled from 'styled-components'

export const Container = styled.div`
  position: relative;

  display: flex;
  height: 73%;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 812px) {
    height: auto;
    width: 100%;
    flex-direction: column;
  }
`

export const Content = styled.div`
  position: relative; 
  width: 40%;
  height: 90%;

  margin: 1em;

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;

  @media screen and (max-width: 812px) {
    width: 85%;
    height: auto;
  }

  &:after{
    display: block;
    position: absolute;
    top: 0;
    right: 0;

    content:"";
    width: 3px;
    height: 100%;

    border-radius: 2px;
    background: #fff;
    opacity: 0.9;
  }
`

export const TitleContainer = styled.div`
  width: 100%;
  height: 10%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

export const Title = styled.p`
  position: relative;
  display: block;
  width: 125%;

  font-family: 'Crash';
  font-size: 3em;
  text-align: center;
  background: -webkit-linear-gradient(#feaf12, #ff4304);
  -webkit-text-stroke: 1.25px rgb(0, 0, 0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  transform: scaleX(0.75);
  transform-origin: 50%;
`

export const LeaderboardsContainer = styled.div`
  width: 100%;
  height: 90%;

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
`

export const Prize = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  flex-direction: column;
  margin: 1em;
  width: 40%;
  height: 90%;

  @media screen and (max-width: 812px) {
    margin: 0;
    width: 90%;
    height: auto;
    margin-bottom: 1em;

    &::-webkit-scrollbar { width: 0.3em; }

  }
`

export const Image = styled.img`
  display: block;
  width: 70%;

  object-fit: contain;
  border-radius: 20px;
  box-shadow: 1px 0px 25px rgba(0, 0, 100, 0.5);
`